<template>
  <v-list-item :to="to" :ripple="{ class: 'primary--text' }">
    <v-list-item-action>
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title class="text-left" >{{ label }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "SideMenuItem",
  props: {
    to: {
      type: String,
      default: "/",
    },
    icon: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    }
  },
};
</script>